import React from "react";

import "./PopupCardTemplate.css";

function PopupCardTemplate({
  heading = "",
  children = null,
  handleClosePopup = null,
  isCloseButtonDisable = false,
  themeNumber = null,
  width
}) {
  const themeList = ["error"];
  return (
    <div
      className={`popupCrdTemplat ${
        themeList[themeNumber]
          ? `popupCrdTemplat--${themeList[themeNumber]}`
          : ""
      }`}
      style={{maxWidth: (width ? width : "")}}
    >
      {(heading || !isCloseButtonDisable) && (
        <div className="make-flex space-between">
          {heading && <h2 className="font22 latoBlack blackText">{heading}</h2>}
          {!isCloseButtonDisable && (
            <span
              className="append-left20 cm__closeButton"
              onClick={handleClosePopup}
            />
          )}
        </div>
      )}

      {children}
    </div>
  );
}

export default PopupCardTemplate;
